import React from 'react';
import renderHTML from 'react-render-html';
import SummaryDetails from '../summary-details/summary-details';
import './in-dial-number-detailing.css';

const InDialNumberDetailing = (props) => {
  const { inDialNumberSection, inDialDetailingShowMoreText, handleInDialShowAdvanceFeatures } = props;
  return (
    <div className="in-dial-number-detailing">
      <SummaryDetails summaryTitle={inDialNumberSection.summaryTitle} summaryText={inDialNumberSection.summary} />
      <div className="row learn-more-btn">
        <div className="col-12">
          <button type="button" className={`btn btn-text ${inDialDetailingShowMoreText ? 'clicked' : ''}`} onClick={handleInDialShowAdvanceFeatures}>
            {inDialNumberSection.learnMoreText}
            {inDialDetailingShowMoreText === false && <i className="td-icon icon-ui-down-arrow-thick" />}
          </button>
        </div>
        {inDialDetailingShowMoreText &&
        <React.Fragment>
          <div className="arrow left-item" />
          <div className="arrow right-item" />
        </React.Fragment>
        }
      </div>
      {inDialDetailingShowMoreText &&
        <div className="row learn-more-content">
          <div className="col-12">
            {renderHTML(inDialNumberSection.learnMoreSummary)}
          </div>
        </div>
      }
    </div>
  );
};

export default React.memo(InDialNumberDetailing);
